import MediaThumbnail from "../../../components/common/MediaThumbnail";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2, ImageOff, Layers, MapPin, Scan } from "lucide-react";

function ProjectImage({ src, alt }) {
  const [failed, setFailed] = useState(false);
  return failed || !src
    ? <span className="public-project-image-fallback" role="img" aria-label={alt}><ImageOff aria-hidden="true" /><span>Image unavailable</span></span>
    : <MediaThumbnail src={src} alt={alt} loading="lazy" decoding="async" onError={() => setFailed(true)} />;
}

export default function PublicProjectCard({ project }) {
  const completed = String(project.status).toLowerCase() === "completed";
  const status = completed ? "Completed" : /^(ongoing|in progress|in_progress)$/i.test(project.status) ? "Ongoing" : project.status;
  const gallery = (project.images || []).filter((item) => typeof item === "string" ? item : item?.url || item?.imageUrl || item?.thumbnailUrl);
  const total = Math.max(gallery.length, project.imageCount || 0);
  const remaining = Math.max(0, total - 2);
  return <article className="public-project-card">
    <div className="public-project-card-surface">
      <div className="public-project-card-cover">
        <ProjectImage src={project.imageUrl} alt={project.title} />
        {status && <span className={completed ? "public-project-status is-completed" : "public-project-status is-ongoing"}><i aria-hidden="true" />{status}</span>}
      </div>
      <div className="public-project-card-body">
        <h3>{project.projectCode || project.id}</h3>
        <p className="public-project-location"><MapPin aria-hidden="true" />{project.location}</p>
        <dl className="public-project-specs">
          <div><dt><Scan aria-hidden="true" /><span className="visually-hidden">Area</span></dt><dd>{project.area || "Not specified"}</dd></div>
          <div><dt><Building2 aria-hidden="true" /><span className="visually-hidden">Foundation</span></dt><dd>{project.floorLabel || (project.floors != null ? project.floors + " floors" : "Not specified")}</dd></div>
          <div><dt><Layers aria-hidden="true" /><span className="visually-hidden">Category</span></dt><dd>{project.category}</dd></div>
        </dl>
        <div className="public-project-card-bottom">
          <div className="public-project-thumbnails">{gallery.slice(0, 3).map((src, index) => <div className="public-project-thumbnail" key={src + index}>
            <ProjectImage src={src} alt={project.title + " — view " + (index + 1)} />
            {index === 2 && <span className="public-project-more-images" aria-label={remaining + " more project images"}>+{remaining}</span>}
          </div>)}</div>
          <Link className="public-project-open" to={"/project/" + encodeURIComponent(project.id)} state={project} aria-label={"View project " + (project.projectCode || project.id)}><ArrowRight aria-hidden="true" /></Link>
        </div>
      </div>
    </div>
  </article>;
}
